import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import { RelativeWrapper, FlexCenterJustifyEndWrapper } from 'wrappers'
import { SolidButton } from 'molecules';
import Controller from './controller';
import internalState from './internalState';
import { BodyWrapper, CategoryRowWrapper, ListWrapper } from './wrappers';
import { SecondaryTextXs, Switch } from 'atoms';

const containerRef = React.createRef();

export const definition = {
  name: "SkillsDropdown",
  controller: Controller,
  initialProps: ({ categories, categoryIds }) => ({ categories, categoryIds }),
  props: internalState,
  elements: [
    {
      component: wrap(SolidButton, FlexCenterJustifyEndWrapper),
      name: 'ToggleButton',
      bindings: ({ isOpen }) => ({ isOpen, containerRef, title: '+ Add A New Skill', big: true })
    },
    {
      wrapper: BodyWrapper,
      name: 'Body',
      ref: containerRef,
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          wrapper: ListWrapper,
          name: 'List',
          elements: [
            {
              wrapper: CategoryRowWrapper,
              name: 'CategoryRow',
              isListOf: 'categories',
              elements: [
                {
                  component: SecondaryTextXs,
                  name: 'CategoryName',
                  displayValue: ({ category }) => category.name,
                },
                {
                  component: Switch,
                  name: 'Switch',
                  bindings: ({ category, categoryIds }) => ({ 
                    category, 
                    value: categoryIds.includes(category.id) || category.children.some(c => categoryIds.includes(c.id)) 
                  })
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}

const SkillsDropdown = ContainerComponent(definition);

export default wrap(SkillsDropdown, RelativeWrapper);
